import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs'
import { Card } from '@/components/ui/card'
import PaymentForm from '@/components/features/payments/PaymentForm'
import PaymentHistory from '@/components/features/payments/PaymentHistory'

export default function PaymentsPage() {
  const [tab, setTab] = useState('new')
  const qc = useQueryClient()

  const handlePaymentSuccess = () => {
    qc.invalidateQueries({ queryKey: ['payments'] })
    setTab('history')
  }

  return (
    <div className="space-y-4">
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="new">New Payment</TabsTrigger>
          <TabsTrigger value="history">Payment History</TabsTrigger>
        </TabsList>

        <TabsContent value="new">
          <Card className="p-6">
            <PaymentForm onSuccess={handlePaymentSuccess} />
          </Card>
        </TabsContent>

        <TabsContent value="history">
          <Card className="p-6">
            <PaymentHistory />
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  )
}
